"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iDeleteTRMVREntry = exports.iGetTRMVRMeterEntries = exports.iCreateTRMVRMeterEntry = exports.iTRMVRMeterEntry = exports.iMeasurement = exports.iMeasurementValues = void 0;
const t = require("io-ts");
const User = require("./user");
const _iMeasurementValues = t.interface({
    correct: t.number,
    wrong: t.number
});
exports.iMeasurementValues = t.clean(_iMeasurementValues);
const _iMeasurement = t.interface({
    name: t.string,
    value: _iMeasurementValues
});
exports.iMeasurement = t.clean(_iMeasurement);
// contains all columns from entries table dont know if
// use this for get and update
const _iTRMVRMeterEntry = t.partial({
    id: t.number,
    uuid: t.string,
    trmeter_uuid: t.string,
    date: t.union([t.string, t.number]),
    ui_date: t.string,
    week_number: t.number,
    draft: t.boolean,
    meter_type: t.union([t.literal('TRMETER'), t.literal('MVRMETER')]),
    created_by: t.union([t.number, User.iUser]),
    ui_created_by: t.string,
    measurements: t.array(_iMeasurement),
    folder_uuid: t.string,
    folder_id: t.number,
    employer_signature: t.string,
    employee_signature: t.string,
    created_at: t.union([t.string, t.number]),
    updated_at: t.union([t.string, t.number]),
    deleted_at: t.union([t.string, t.number]),
    remark_status: t.union([t.literal('PENDING'), t.literal('COMPLETED')])
});
const _iDeleteTRMVREntry = t.intersection([
    t.interface({
        entry_uuid: t.string,
        folder_id: t.number
    }),
    t.partial({
        remark_status: t.union([t.literal('PENDING'), t.literal('COMPLETED')]),
        remarks: t.array(t.number)
    })
]);
exports.iTRMVRMeterEntry = t.clean(_iTRMVRMeterEntry);
// interface + partial on returned data
const _iCreateTRMVRMeterEntry = t.intersection([
    t.interface({
        date: t.union([t.string, t.number]),
    }),
    t.partial({
        projectId: t.number,
        id: t.number,
        uuid: t.string,
        week_number: t.number,
        draft: t.boolean,
        trmeter_uuid: t.string,
        created_by: t.number,
        folder_uuid: t.string,
        folder_id: t.number,
        created_at: t.union([t.string, t.number]),
        meter_type: t.union([t.literal('TRMETER'), t.literal('MVRMETER')]),
    })
]);
exports.iCreateTRMVRMeterEntry = t.clean(_iCreateTRMVRMeterEntry);
const _iGetTRMVRMeterEntries = t.interface({
    id: t.number,
    uuid: t.string,
    date: t.union([t.string, t.number]),
    ui_date: t.string,
    draft: t.boolean,
    week_number: t.number,
    created_by: t.union([t.number, User.iUser]),
    ui_created_by: t.string,
    employer_signature: t.string,
    employee_signature: t.string,
    remark_status: t.union([t.literal('PENDING'), t.literal('COMPLETED')])
});
exports.iGetTRMVRMeterEntries = t.clean(_iGetTRMVRMeterEntries);
exports.iDeleteTRMVREntry = t.clean(_iDeleteTRMVREntry);
//# sourceMappingURL=trmvrmeterEntry.js.map